module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-03-b5a38a5ee9219f218e7070e177d262c1.jpg";